var _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24578 18.9757H28.3379V1.75H1.24937V20.2257V25.022L8.46491 19.2496L8.80731 18.9757H9.24578Z",
    fill: "#5A51A0",
    stroke: "#CED4DA",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9027 27.8526H14.8105V10.627H41.8991V29.1026V33.899L34.6835 28.1265L34.3411 27.8526H33.9027Z",
    fill: "#5A51A0",
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.957,
    y: 17.8008,
    width: 2.5,
    height: 2.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.123,
    y: 17.8008,
    width: 2.5,
    height: 2.5,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2871,
    y: 17.8008,
    width: 2.5,
    height: 2.5,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.9278dba47352089b7c9dd4b7c91b5799.svg";
export { ForwardRef as ReactComponent };